import { useTheme } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import ReactApexcharts from 'react-apexcharts'
import { formatNumber } from '../../../common/commonFunctions'

// import { useEffect, useState } from 'react'


interface Tickers {
  values: any[]
  legends: any[]
}

const LemurDashboardCCByTicker = (props: Tickers) => {
  const { legends, values } = props
  const [height, setHeight] = useState<string>('230')
  const series = values
  const theme = useTheme()

  const options = {
    theme: {
      mode: theme.palette.mode
    },
    series: series,
    chart: {
      width: 380
    },
    labels: legends,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }
    ],
    colors: [
      '#4635A6',
      '#7EAFD8',
      '#C063B1',
      '#1A9545',
      '#EADB97',
      '#5791FF',
      '#FF6A81',
      '#6C8996',
      '#BD38EB',
      '#5DD0DD'
    ],
    tooltip: {
      x: {
        show: false
      },
      y: {
        formatter: function (value: any) {
          return formatNumber.format(parseInt(value))
        }
      }
    }
  }

  useEffect(() => {
    if (window.innerWidth >= 3072) {
      setHeight('auto')
    } else if (window.innerWidth >= 2560) {
      setHeight('auto')
    } else if (window.innerWidth >= 1920) {
      setHeight('230vh')
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 3072) {
        setHeight('auto')
      } else if (window.innerWidth >= 2560) {
        setHeight('auto')
      } else if (window.innerWidth >= 1920) {
        setHeight('200vh')
      }
    })
  })

  return <ReactApexcharts type='pie' height={height} options={options} series={series} />
}

export default LemurDashboardCCByTicker
